import { render, staticRenderFns } from "./MyProfileLoginDetails.vue?vue&type=template&id=f4dbe048&scoped=true"
import script from "./MyProfileLoginDetails.vue?vue&type=script&lang=js"
export * from "./MyProfileLoginDetails.vue?vue&type=script&lang=js"
import style0 from "./MyProfileLoginDetails.vue?vue&type=style&index=0&id=f4dbe048&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4dbe048",
  null
  
)

export default component.exports